export default "__VITE_ASSET__DJmWJsd$__"